import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { loginAdmin, seedDatabase } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Building2, Lock, Mail, ArrowLeft, AlertCircle } from 'lucide-react';

var AdminLogin = function() {
  var _useState1 = useState('');
  var email = _useState1[0];
  var setEmail = _useState1[1];
  
  var _useState2 = useState('');
  var password = _useState2[0];
  var setPassword = _useState2[1];
  
  var _useState3 = useState(false);
  var loading = _useState3[0];
  var setLoading = _useState3[1];
  
  var _useState4 = useState('');
  var error = _useState4[0];
  var setError = _useState4[1];
  
  var navigate = useNavigate();
  var auth = useAuth();

  // Redirect if already authenticated
  useEffect(function() {
    if (auth.isAuthenticated) {
      navigate('/admin/dashboard', { replace: true });
    }
  }, [auth.isAuthenticated, navigate]);

  var handleSubmit = async function(e) {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      var response = await loginAdmin(email, password);
      auth.login(response.data.access_token);
      navigate('/admin/dashboard');
    } catch (err) {
      console.error('Login error:', err);
      if (err.response && err.response.status === 401) {
        setError('Credenciales inválidas. Verifica tu email y contraseña.');
      } else {
        setError('Error al iniciar sesión. Intenta de nuevo.');
        try {
          await seedDatabase();
        } catch (seedErr) {
          console.error('Seed error:', seedErr);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#d1223b] to-[#8a1627] flex flex-col">
      {/* Header */}
      <header className="py-6 px-4">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors"
          data-testid="back-to-home"
        >
          <ArrowLeft className="w-5 h-5" />
          <span>Volver al inicio</span>
        </Link>
      </header>

      {/* Login Card */}
      <main className="flex-grow flex items-center justify-center px-4 pb-12">
        <Card className="w-full max-w-md shadow-2xl border-0">
          <CardHeader className="text-center pb-2">
            <div className="w-16 h-16 rounded-2xl bg-[#d1223b] flex items-center justify-center mx-auto mb-4">
              <Building2 className="w-8 h-8 text-white" />
            </div>
            <CardTitle className="text-2xl" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Panel de Administración
            </CardTitle>
            <CardDescription>
              Club Cámara Lanzarote y La Graciosa
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && (
                <div className="flex items-center gap-2 p-3 bg-red-50 border border-red-100 rounded-lg text-red-600 text-sm" data-testid="login-error">
                  <AlertCircle className="w-4 h-4 flex-shrink-0" />
                  <span>{error}</span>
                </div>
              )}

              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                  <Input
                    id="email"
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={function(e) { setEmail(e.target.value); }}
                    className="pl-10 h-11"
                    required
                    data-testid="email-input"
                  />
                </div>
              </div>

              <div className="space-y-2">
                <Label htmlFor="password">Contraseña</Label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                  <Input
                    id="password"
                    type="password"
                    placeholder="••••••••"
                    value={password}
                    onChange={function(e) { setPassword(e.target.value); }}
                    className="pl-10 h-11"
                    required
                    data-testid="password-input"
                  />
                </div>
              </div>

              <Button 
                type="submit" 
                className="w-full btn-primary h-11"
                disabled={loading}
                data-testid="login-btn"
              >
                {loading ? (
                  <span className="flex items-center gap-2">
                    <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                    Iniciando sesión...
                  </span>
                ) : (
                  'Iniciar Sesión'
                )}
              </Button>
            </form>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default AdminLogin;
